import React, { useState } from 'react';

import { useTheme } from '@emotion/react';
import { Container, Box, Avatar, Typography, IconButton, Grid, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';

import BackupTableIcon from '@mui/icons-material/BackupTable';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { useUser } from '../context/user.context';
import TableCard from '../components/TableCard';

// ======================================================= //

export default function TableList() {

    const {user, updateUser} = useUser();
    const theme = useTheme();

    const [tables, setTables] = useState(user.tables);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [newName, setNewName] = useState('');

    // ------------------------------------------------------- //

    const handleCreate = () => {

        const newTableName = newName.trim() === '' ? 'Unnamed Table' : newName;
        
        const p = tables;
        p.push({
            id: user.lastID++,
            name: newTableName,
            createdAt: Date.now(),
            days: [
                {
                    day: 'Monday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                }, 
                {
                    day: 'Tuesday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                }, 
                {
                    day: 'Wednesday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                },
                {
                    day: 'Thursday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                },
                {
                    day: 'Friday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                },
                {
                    day: 'Saturday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                },
                {
                    day: 'Sunday',
                    periods: [null, null, null, null, null, null, null, null, null, null, null]
                },
            ],
            periods: [
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: false
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: false
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: false
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                },
                {
                    start: "00:00",
                    end: "00:00",
                    hidden: true
                }
            ]
        });

        setTables(p);
        setDialogOpen(false);

        const new_user = {...user};
        new_user.tables = p;

        updateUser(new_user);
    }

    // ------------------------------------------------------- //

    return (
        <Container component="main">

            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >

                <Avatar sx={{ m: 1, bgcolor: theme.palette.primary.main }}>
                    <BackupTableIcon />
                </Avatar>
                
                <Typography
                    component="h1"
                    variant="h4"
                    align="center"
                    color="text.primary"
                    fontWeight="600"
                    marginTop="2vh"
                >
                Time Tables
                </Typography>

                <Typography variant="subtitle" align="center" color="text.secondary" marginBottom={8}>
                    Your tables
                </Typography>

                {
                    // check if user has any tables or not?
                    tables.length === 0 &&
                    
                    <Typography variant="h6" align="center" color="text.secondary">
                        You don't have any tables yet. Click on the new button to create!
                    </Typography>                        
                }

                {
                    // if the user has tables
                    tables.length > 0 &&

                    <Grid container spacing={2}>
                        {tables.map((v, i) => {
                            return <TableCard table={v} index={i} key={i}/>
                        })}
                    </Grid>
                }

                <IconButton color='primary' sx={{marginTop: "8vh"}} onClick={() => setDialogOpen(true)}>
                    <AddCircleIcon />
                </IconButton>

                <Typography variant="caption" display="block" fontWeight="600" marginBottom="5vh">
                    New table
                </Typography>

                <Dialog 
                    open={dialogOpen}
                    fullWidth
                    maxWidth='md'
                >
                    <DialogTitle>Create new table</DialogTitle>
                    <DialogContent>

                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Table Name"
                            type="name"
                            fullWidth
                            variant="standard"
                            onChange={(event) => setNewName(event.target.value)}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleCreate}>Create</Button>
                        <Button color='secondary' onClick={() => setDialogOpen(false)}>Cancel</Button>
                    </DialogActions>
                </Dialog>

            </Box>
            
        </Container>
    )
}

// ======================================================= //